import React from 'react'
import {MainLayout} from "../../../../palette/Palette";
import welcome from "../../../../assets/img/PortadaWebAdmin.png"

function WelcomePage() {
    return (
        <MainLayout>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    margin: 'auto',
                    justifyContent: 'center'
                }}>
                <img src={welcome} alt="" style={{width: '60%', height: '50%', objectFit: 'cover'}}/>
            </div>
        </MainLayout>
    )
}
export default WelcomePage
